import LeftContents from './LeftContents'

export default LeftContents
